import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { toastSuccess, toastError } from '../../shared/toastHelper';
import Popup from "reactjs-popup";
import { documentNoun } from "./statusLabels";

const modalContentStyle = {
  border: "none",
  borderRadius: "8px",
  boxShadow: "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  width: "500px",
  padding: "0",
  background: "var(--sl-bg-primary, #fff)"
};

const SendRentalInvoiceModal = ({
  csrfToken,
  team,
  rentalInvoice,
  status,
  onClose,
  onSuccess,
  isOpen
}) => {
  const [email, setEmail] = useState('');
  const [isSending, setIsSending] = useState(false);
  const effectiveStatus = status ?? rentalInvoice.status;

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSending(true);

    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    axios.post(`/teams/${team.id}/rental_invoices/${rentalInvoice.id}/send_invoice`, {
      to: email
    })
    .then(() => {
      toastSuccess(`${documentNoun(effectiveStatus)} sent successfully`);
      onSuccess();
    })
    .catch((error) => {
      toastError(error.response?.data?.error || `Failed to send ${documentNoun(effectiveStatus).toLowerCase()}`);
    })
    .finally(() => {
      setIsSending(false);
    });
  };

  return (
    <Popup
      open={isOpen}
      modal
      closeOnDocumentClick={false}
      onClose={onClose}
      contentStyle={modalContentStyle}
    >
      <div className="modal-content">
        <div className="modal-header" style={{ borderBottom: 'none' }}>
          <h5 className="modal-title">Send {documentNoun(effectiveStatus)}</h5>
          <button type="button" className="close" onClick={onClose} aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="email">Recipient Email</label>
              <input
                type="email"
                className="form-control"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="modal-footer" style={{ borderTop: 'none' }}>
            <button type="button" className="btn btn-setlist-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-setlist-primary" disabled={isSending}>
              {isSending ? 'Sending...' : `Send ${documentNoun(effectiveStatus)}`}
            </button>
          </div>
        </form>
      </div>
    </Popup>
  );
};

SendRentalInvoiceModal.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  rentalInvoice: PropTypes.object.isRequired,
  status: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired
};

export default SendRentalInvoiceModal;
